<template lang="pug">
  v-btn(
    plain
    @click="viewDocument"
    class="button-view-document"
    :data-test="`button-view-document-${rowIndex}`"
  )
    e-svg-icon(name="eye")
</template>

<script>
export default {
  name: 'EButtonEntityView',
  props: {
    item: {
      type: Object,
      default: null
    },
    prefix: {
      type: String,
      default: null
    },
    rowIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    viewDocument() {
      this.$router.push({ name: `${this.prefix}-id`, params: { id: this.item.id } })
    }
  }
}
</script>

<style scoped lang="scss">
.button-view-document {
  background: none !important;
  padding: 0 4px !important;
  height: 24px !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
}
</style>
